import { call } from 'redux-saga/effects';
import axios from 'axios';

const Api = {
  recoverPassword: params =>
    axios.post('/api/client/recover', params)
};

function* recoverPassword({ payload: { params, onStart, onSuccess, onError } }) {
  onStart && onStart();
  try {
    const { status } = yield call(Api.recoverPassword, params);
    if (status === 200) {
      onSuccess && onSuccess();
    }
  } catch (error) {
    onError && onError(error);
  }
}

export default recoverPassword;